import React from 'react';
import LazyLoad from 'react-lazyload';

const VenueCard = ({ image, venueName, city, area, venueUniqueLink, categoryName }) => {
  return (
    <div className="venue-card">
      <div className="venue-card__image-container">
      <LazyLoad>
        <img 
          src={`//media.bookeventz.com/441x272/html/bookeventz.com/images/restaurant-picture/${image}`}
          alt={venueName} 
          className="venue-card__image"
          onError={(e) => {
            e.target.onerror = null; // Prevents looping if fallback also fails
            e.target.src = "https://media.bookeventz.com/html/bookeventz.com/asset/images/maineBannervendorListing_new.jpg"; // Use your fallback image path
          }}
        />
      </LazyLoad>
      </div>
      <a href={`https://bookeventz.com/banquets/${city}/${area}/${venueUniqueLink}`} target="_blank" >
        <p className="venue-card__title">{venueName}</p>
      </a>
    </div>
  );
};

export default VenueCard;
